
export enum EnhancementType {
    AEMBER = "AEMBER",
    CAPTURE = "CAPTURE",
    DAMAGE = "DAMAGE",
    DRAW = "DRAW",
    DISCARD = "DISCARD",
    POWER = "POWER",
}
